import { useMemo } from "react";
import Plot from "react-plotly.js";

export default function PCRDashboard({ data }) {

    const latest = data?.pcr_latest || [];
    const history = data?.pcr_history || [];

    const safeNumber = (value) => {

        const num = Number(value);

        return Number.isFinite(num)
            ? num
            : null;

    };

    const validLatest = useMemo(() => {

        return latest.filter(
            row =>
                safeNumber(
                    row.total_pcr
                ) !== null
        );

    }, [latest]);

    const niftyHistory = useMemo(() => {

        return history.filter(
            row =>
                row.symbol === "NIFTY"
        );

    }, [history]);

    const bankNiftyHistory = useMemo(() => {

        return history.filter(
            row =>
                row.symbol === "BANKNIFTY"
        );

    }, [history]);

    const highestPCR = useMemo(() => {

        return [...validLatest]
            .sort(
                (a, b) =>
                    safeNumber(
                        b.total_pcr
                    ) -
                    safeNumber(
                        a.total_pcr
                    )
            )
            .slice(0, 10);

    }, [validLatest]);

    const lowestPCR = useMemo(() => {

        return [...validLatest]
            .sort(
                (a, b) =>
                    safeNumber(
                        a.total_pcr
                    ) -
                    safeNumber(
                        b.total_pcr
                    )
            )
            .slice(0, 10);

    }, [validLatest]);

    const niftyLatest =
        validLatest.find(
            row =>
                row.symbol === "NIFTY"
        );
    console.log('NIFTY LATEST',niftyLatest)
    console.log('LATEST',latest)

    const bankLatest =
        validLatest.find(
            row =>
                row.symbol === "BANKNIFTY"
        );

    return (

        <div className="space-y-6">

            {/* SUMMARY CARDS */}

            <div
                className="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    lg:grid-cols-4
                    gap-4
                "
            >

                <PCRCard
                    title="NIFTY PCR"
                    value={
                        safeNumber(
                            niftyLatest?.total_pcr
                        )?.toFixed(2) || "-"
                    }
                />

                <PCRCard
                    title="BANKNIFTY PCR"
                    value={
                        safeNumber(
                            bankLatest?.total_pcr
                        )?.toFixed(2) || "-"
                    }
                />

                <PCRCard
                    title="Highest PCR"
                    value={
                        highestPCR.length
                            ? `${highestPCR[0].symbol} (${safeNumber(
                                  highestPCR[0].total_pcr
                              )?.toFixed(2)})`
                            : "-"
                    }
                />

                <PCRCard
                    title="Lowest PCR"
                    value={
                        lowestPCR.length
                            ? `${lowestPCR[0].symbol} (${safeNumber(
                                  lowestPCR[0].total_pcr
                              )?.toFixed(2)})`
                            : "-"
                    }
                />

            </div>

            {/* PCR TREND */}

            <div
                className="
                    bg-slate-950
                    rounded-3xl
                    border
                    border-slate-800
                    p-4
                "
            >

                <h3
                    className="
                        text-white
                        text-lg
                        font-semibold
                        mb-4
                    "
                >
                    PCR Trend
                </h3>

                <Plot

                    data={[

                        {
                            x:
                                niftyHistory.map(
                                    row =>
                                        row.timestamp
                                ),

                            y:
                                niftyHistory.map(
                                    row =>
                                        safeNumber(
                                            row.total_pcr
                                        )
                                ),

                            type: "scatter",
                            mode: "lines",
                            name: "NIFTY"
                        },

                        {
                            x:
                                bankNiftyHistory.map(
                                    row =>
                                        row.timestamp
                                ),

                            y:
                                bankNiftyHistory.map(
                                    row =>
                                        safeNumber(
                                            row.total_pcr
                                        )
                                ),

                            type: "scatter",
                            mode: "lines",
                            name: "BANKNIFTY"
                        }

                    ]}

                    layout={{
                        height: 500,

                        paper_bgcolor:
                            "#020617",

                        plot_bgcolor:
                            "#020617",

                        font: {
                            color:
                                "#cbd5e1"
                        },

                        xaxis: {
                            type: "date"
                        },

                        yaxis: {
                            title:
                                "PCR"
                        },

                        legend: {
                            orientation:
                                "h"
                        }
                    }}

                    config={{
                        responsive: true,
                        displayModeBar: false
                    }}

                    style={{
                        width: "100%"
                    }}

                />

            </div>

            {/* EXTREME PCR TABLES */}

            <div
                className="
                    grid
                    grid-cols-1
                    xl:grid-cols-2
                    gap-6
                "
            >

                <PCRTable
                    title="Highest PCR"
                    rows={highestPCR}
                />

                <PCRTable
                    title="Lowest PCR"
                    rows={lowestPCR}
                />

            </div>

        </div>

    );

}

function PCRCard({
    title,
    value
}) {

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-5
            "
        >

            <div
                className="
                    text-slate-400
                    text-sm
                "
            >
                {title}
            </div>

            <div
                className="
                    text-2xl
                    font-bold
                    text-white
                    mt-2
                "
            >
                {value}
            </div>

        </div>

    );

}

function PCRTable({
    title,
    rows
}) {

    const safeNumber = (value) => {

        const num = Number(value);

        return Number.isFinite(num)
            ? num
            : null;

    };

    return (

        <div
            className="
                bg-slate-950
                border
                border-slate-800
                rounded-3xl
                p-4
            "
        >

            <h3
                className="
                    text-white
                    font-semibold
                    mb-4
                "
            >
                {title}
            </h3>

            <table
                className="
                    w-full
                    text-sm
                "
            >

                <thead>

                    <tr
                        className="
                            text-slate-400
                            border-b
                            border-slate-800
                        "
                    >

                        <th
                            className="
                                text-left
                                py-2
                            "
                        >
                            Symbol
                        </th>

                        <th
                            className="
                                text-right
                                py-2
                            "
                        >
                            PCR
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {rows.map(row => (

                        <tr
                            key={row.symbol}
                            className="
                                border-b
                                border-slate-900
                            "
                        >

                            <td
                                className="
                                    py-2
                                    text-slate-200
                                "
                            >
                                {row.symbol}
                            </td>

                            <td
                                className="
                                    py-2
                                    text-right
                                    text-white
                                "
                            >
                                {
                                    safeNumber(
                                        row.total_pcr
                                    )?.toFixed(2)
                                    || "-"
                                }
                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}